{
	"termsAndConditions": {
		"title": "Vilkår og betingelser",
		"submitTitle": "Godta og fortsett til personvernerklæringen"
	},
	"privacyPolicy": {
		"title": "Personvernerklæring",
		"submitTitle": "Godta og lukk",
		"backTitle": "Tilbake"
	}
}
